import * as React from 'react';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import { LockClosedIcon } from '@heroicons/react/24/solid'; // หากไม่มีให้ลบบรรทัดนี้ออก

const Login = () => {
    localStorage.clear()

    const handleOnSubmit = (e) => {
        e.preventDefault()
        const obj = {}
        const form = document.getElementById('login')
        const formData = new FormData(form)
        for (const [key, value] of formData) {
            obj[key] = value
        }

        axios.post(`https://www.phoenix-md.com/api/login`, obj).then((res) => {
            const { status, token } = res.data || {}
            if (status === 'ok') {
                localStorage.setItem("token", token)
                window.location = "/home"
            } else {
                alert('ผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง')
            }
        }).catch((error) => {
            console.log(error.message)
        })
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 px-4">
            <div className="w-full max-w-md bg-white p-10 rounded-2xl shadow-xl border border-gray-100">
                
                {/* Header Section */}
                <div className="flex flex-col items-center mb-8">
                    <div className="bg-indigo-100 p-3 rounded-full mb-4">
                        <LockClosedIcon className="h-8 w-8 text-indigo-600" />
                    </div>
                    <h2 className="text-3xl font-extrabold text-gray-900 tracking-tight">
                        ยินดีต้อนรับ
                    </h2>
                    <p className="mt-2 text-sm text-gray-500">
                        กรุณาเข้าสู่ระบบเพื่อใช้งานระบบ Phoenix
                    </p>
                </div>

                <form onSubmit={handleOnSubmit} id="login" className="space-y-5">
                    <div className="space-y-4">
                        <TextField
                            fullWidth
                            id="email"
                            name="email"
                            label="อีเมล"
                            type="email"
                            required
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '&:hover fieldset': { borderColor: '#4f46e5' },
                                },
                            }}
                        />
                        <TextField
                            fullWidth
                            id="password"
                            name="password"
                            label="รหัสผ่าน"
                            type="password"
                            required
                            variant="outlined"
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '&:hover fieldset': { borderColor: '#4f46e5' },
                                },
                            }}
                        />
                    </div>

                    <div className="pt-2">
                        <button
                            type="submit"
                            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-semibold text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-200 transform active:scale-[0.98]"
                        >
                            เข้าสู่ระบบ
                        </button>
                    </div>
                </form>

                {/* Footer Section (Optional) */}
                <div className="mt-8 text-center">
                    <p className="text-xs text-gray-400">
                        &copy; 2024 Phoenix Medical. All rights reserved.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Login